import React from "react";

const DefferedAction = (): JSX.Element => {
  const handleSubmit = (): void => {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        if (registration.waiting) {
          registration.waiting.postMessage("SKIP_WAITING");
          return;
        }
      }
    });
  };

  const handleCancel = (): void => {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        if (registration.waiting) {
          registration.waiting.postMessage("NO_SKIP_WAITING");
        }
      }
    });
  };

  return (
    <div className="sw_popup" id="sw-toast">
      An Update is Available
      <div>
        <button onClick={handleSubmit}>Update</button>
        <button onClick={handleCancel}>Don't Update</button>
      </div>
    </div>
  );
};

export default DefferedAction;
